/*
 * Copyright (c) Nexign, JSC, 2020-2025.
 */
/**
 * The reducer for the widget Search Accounts
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.3.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { TWidgetSearchAccountsActions } from './types/widgetSearchAccountsActionTypes';
import { EWidgetSearchAccountsField, IWidgetSearchAccountsItem } from './types/widgetSearchAccountsTypes';
import {
    WIDGET_SEARCH_ACCOUNTS_LOAD_LIST,
    WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_FAILED,
    WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_SUCCESSFUL,
    WIDGET_SEARCH_ACCOUNTS_SET_ACCOUNT,
    WIDGET_SEARCH_ACCOUNTS_SET_SEARCH_VALUE,
} from './widgetSearchAccountsConstants';

export interface IWidgetSearchAccountsReducer {
    accountList: IWidgetSearchAccountsItem[];
    isLoading: boolean;
    hasMore: boolean;
    message: string;
    searchValue: string;
    selectedAccount: IWidgetSearchAccountsItem;
}

export const initialWidgetSearchAccountsItem: IWidgetSearchAccountsItem = {
    id: 0,
    [EWidgetSearchAccountsField.balance]: '',
    [EWidgetSearchAccountsField.subsCount]: '',
    [EWidgetSearchAccountsField.number]: '',
    [EWidgetSearchAccountsField.region]: '',
    [EWidgetSearchAccountsField.inn]: '',
    [EWidgetSearchAccountsField.name]: '',
};

export const initialWidgetSearchAccountsState: IWidgetSearchAccountsReducer = {
    accountList: [],
    isLoading: false,
    hasMore: true,
    message: '',
    searchValue: '',
    selectedAccount: initialWidgetSearchAccountsItem,
};

export const widgetSearchAccountsReducer: Reducer<IWidgetSearchAccountsReducer, TWidgetSearchAccountsActions> =
    (state = initialWidgetSearchAccountsState, action: TWidgetSearchAccountsActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIDGET_SEARCH_ACCOUNTS_SET_ACCOUNT:
                    draft.selectedAccount = action.payload.account;
                    break;
                case WIDGET_SEARCH_ACCOUNTS_SET_SEARCH_VALUE:
                    draft.searchValue = action.payload.searchValue;
                    break;
                case WIDGET_SEARCH_ACCOUNTS_LOAD_LIST:
                    draft.isLoading = true;
                    draft.message = '';
                    if (action.payload?.start) draft.accountList = [];
                    break;
                case WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_SUCCESSFUL:
                    draft.isLoading = false;
                    draft.hasMore = action.payload.hasMore;
                    draft.accountList = action.payload.data;
                    break;
                case WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_FAILED:
                    draft.isLoading = false;
                    draft.message = action.payload.message?.toString();
                    break;
                default:
                    break;
            }
        });
